/**
 * Shared submit helper for the ProEpoxy order flows.
 * Posts to /api/proepoxy-orders, handles success/error toasts and navigation.
 */
import API_URL from '@/config/api';
import { toast } from 'sonner';
import { formatApiError } from '@/utils/apiError';

/**
 * @param {object} payload  — { system, mode, items, total, selections }
 * @param {Function} navigate  — useNavigate() hook
 */
export async function submitProEpoxyOrder(payload, navigate) {
  try {
    const res = await fetch(`${API_URL}/api/proepoxy-orders`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        status: 'submitted',
        customer_reference: '',
        delivery_notes: '',
        ...payload,
      }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(formatApiError(err) || 'Order failed');
    }
    const data = await res.json();
    const saved = (data.vouchers_applied || []).reduce((a, v) => a + Number(v.amount || 0), 0);
    if (saved > 0) toast.success(`Order ${data.reference} submitted! Your training voucher saved you £${saved.toFixed(2)} — to pay £${(Number(data.total || 0) - saved).toFixed(2)} excl. VAT.`, { duration: 8000 });
    else if (data.voucher_error) toast.warning(`Order ${data.reference} submitted, but the voucher wasn't applied: ${data.voucher_error}`, { duration: 9000 });
    else toast.success(`Order ${data.reference} submitted!`);
    navigate('/proepoxy/orders');
  } catch (err) {
    toast.error(err.message || 'Order failed');
  }
}
